import { cn } from "@/lib/utils"

export const ADMIN_TABLE_HEAD_TH = [
  "sticky top-0 z-10 border-b border-border bg-muted font-medium text-muted-foreground",
  "backdrop-blur-sm supports-backdrop-filter:bg-muted/80",
].join(" ")

export const ADMIN_TABLE_ROW =
  "cursor-pointer border-b border-border transition-colors last:border-0 hover:bg-muted/60"

export const ADMIN_TABLE_CLASSNAME =
  "relative w-full border-separate border-spacing-0 text-sm [&_tbody_tr:last-child_td:first-child]:rounded-bl-lg [&_tbody_tr:last-child_td:last-child]:rounded-br-lg"

export function statusBadgeClass(status: string): string {
  const map: Record<string, string> = {
    cancelled: "bg-red-500/15 text-red-300",
    confirmed: "bg-sky-500/15 text-sky-300",
    delivered: "bg-emerald-500/15 text-emerald-300",
    fulfilled: "bg-emerald-500/15 text-emerald-300",
    out_for_delivery: "bg-sky-500/15 text-sky-300",
    preparing: "bg-amber-500/15 text-amber-300",
    scheduled: "bg-muted text-muted-foreground",
  }
  return cn(
    "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium capitalize",
    map[status] ?? "bg-muted text-muted-foreground",
  )
}
